module.exports = __webpack_public_path__ + "static/media/Picture10.9795c0c1.jpeg";